/**
 * @function gatheringsAvatar Used to gathering ...
 * @param {string} gatheringId - gathering's id, eg: "qwe....948ijg"
 * @returns {Promise} Promise object represents true for successful group cover upload
 */
export const gatheringsAvatar = (gatheringId) => {
  return `${process.env.REACT_APP_BACKEND_URL}/gatherings/avatar?gathering=${gatheringId}&updated_at=${Date.now()}`
}
